module.exports = __webpack_public_path__ + "img/CPTemp6.70ade8d3.png";